export default __webpack_public_path__ + "static/media/img-3445.cc5137cb.jpeg";